module.exports = "./img/71d939f6722faaa721ca9da252cd3519.jpg";